import axiosApiInstance from "../../app/axios";
import { API_BASE_URL } from "../../app/utils";

/**
 * What the signed-in account may do, from the token rather than from a lookup.
 *
 * Staff identities live only in Keycloak and have no Mongo document, so this endpoint is the one
 * place that answers the question for staff and customers alike.
 */
export const getMyPermissions = () =>
  axiosApiInstance.get(`${API_BASE_URL}/user-store/v1/users/me/permissions`);
